const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    '@global': {
      body: {
        color: 'white',
      },
      h2: {
        color: 'white',
        fontSize: '30px',
      },
      '.ant-form-item-label>label, .ant-form': {
        color: 'white',
      },
    },
    centeredContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      '& .ant-form-item': {
        width: '100%',
      },
    },
    formContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    walletBalanceRow: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 15,
      color: 'white',
    },
    skeleton: {
      height: 20,
      width: 80,
      borderRadius: 5,
      margin: 'auto',
    },
    walletAmountCol: {
      display: 'flex',
      color: theme.secondaryTextColor,
    },
    walletAmountIcon: {
      width: 15,
      marginRight: 5,
    },
    buttonArea: {
      marginTop: 'auto',
      width: '99%',
      borderTop: `1px solid ${theme.borderColor}`,
      paddingTop: 15,
    },
    formItemLabel: {
      color: theme.secondaryTextColor,
      fontWeight: 400,
    },
    copyIcon: {height: 40, alignItems: 'center', display: 'flex'},

    customSelect: {height: 50, alignItems: 'center', display: 'flex'},

    option: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    coinArea: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    coinIcon: {width: 20, marginRight: 10},
    optionBalance: {
      color: theme.secondaryTextColor,
    },
    exchangeRate: {color: '#6E0'},

    qrCodeArea: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    spinContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: 125,
      width: 125,
      justifyContent: 'center',
      alignItems: 'center',
    },
    exchangeRateContainer: {
      textAlign: 'center',
      lineHeight: '35px',
      color: 'white',
      margin: '15px 0',
      padding: '0 15px',
      height: 35,
      width: 'fit-content',
      borderRadius: 10,
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
    },
    depositDescription: {
      width: 'fit-content',
      textAlign: 'center',
    },
    video: {
      width: '100%',
    },
    depositAmountInput: {
      height: 50,
      alignItems: 'center',
      display: 'flex',
    },
    depositButton: {
      width: '100%',
    },
    backButton: {},
    tonQrCodeArea: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
    },
    qrCodeAndConnectWalletButtonArea: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-evenly',
      alignItems: 'center',
    },
    tonReminder: {margin: '10px 0', color: 'red', textAlign: 'left', fontSize: 12},
    tonConnectOrQrCodeArea: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '15px 0',
    },
    tonConnectButton: {
      // '& button': {
      //   width: '100%',
      // },
    },
    fullWidthSpin: {
      width: '100%',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
